import { useState } from 'react';
import { NavLink, Outlet, Link, useNavigate } from 'react-router-dom';
import {
  FiGrid, FiBox, FiLayers, FiImage, FiSliders, FiInbox, FiSettings, FiLogOut, FiMenu, FiExternalLink,
  FiHome, FiFolder,
} from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';
import { useSettings } from '../../context/SettingsContext';
import '../../styles/admin.css';

const nav = [
  { to: '/admin', label: 'Dashboard', icon: <FiGrid />, end: true },
  { to: '/admin/home-content', label: 'Home Content', icon: <FiHome /> },
  { to: '/admin/categories', label: 'Categories', icon: <FiFolder /> },
  { to: '/admin/products', label: 'Products', icon: <FiBox /> },
  { to: '/admin/services', label: 'Services', icon: <FiLayers /> },
  { to: '/admin/banners', label: 'Banners', icon: <FiImage /> },
  { to: '/admin/form-fields', label: 'Query Form', icon: <FiSliders /> },
  { to: '/admin/queries', label: 'Enquiries', icon: <FiInbox /> },
  { to: '/admin/settings', label: 'Settings', icon: <FiSettings /> },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const { settings } = useSettings();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/admin/login'); };

  return (
    <div className="admin">
      {open && <div className="asidebar__overlay" onClick={() => setOpen(false)} />}
      <aside className={`asidebar ${open ? 'open' : ''}`}>
        <Link to="/admin" className="asidebar__brand" onClick={() => setOpen(false)}>
          <img src={settings?.logo || '/logo.png'} alt="logo" />
          <span>{settings?.siteName || 'Kortex'}</span>
        </Link>
        <nav className="asidebar__nav">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} className="anav-link" onClick={() => setOpen(false)}>
              {n.icon} {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="asidebar__foot">
          <a href="/" target="_blank" rel="noreferrer" className="anav-link"><FiExternalLink /> View site</a>
          <button className="anav-link" style={{ width: '100%', background: 'none', border: 'none', cursor: 'pointer' }} onClick={handleLogout}>
            <FiLogOut /> Logout
          </button>
        </div>
      </aside>

      <div className="amain">
        <div className="atopbar">
          <button className="atopbar__burger" onClick={() => setOpen(true)}><FiMenu /></button>
          <div style={{ flex: 1 }} />
          <div className="flex center gap">
            <span className="muted" style={{ fontSize: 14 }}>Hi, {user?.name}</span>
            <div className="scard__icon" style={{ margin: 0, width: 38, height: 38, fontSize: 15 }}>
              {(user?.name || 'A')[0].toUpperCase()}
            </div>
          </div>
        </div>
        <div className="acontent">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
